<div class="navbar navbar-fixed navbar-toggleable-sm navbar-deloitte-light sticky">
    <div class="container justify-content-between pl-0 pl-xl-3 pr-0 pr-xl-3">
        <div class="navbar-brand hidden-md-down col-3">
            <span class="navbar-mobile-title mr-2">
                Location Comparison
            </span>
        </div>

        <div class="navbar-brand hidden-md-up col-12 mb-3">
            <span class="navbar-mobile-title mr-2">
                Location Comparison
            </span>
        </div>

        <div class="col p-0 pr-xl-3">
            <div class="row">
                <div class="col-xs-12 col-md-4 mb-3 mb-md-0">
                    <ng-select [clearable]="true"
                               [items]="countries"
                               bindLabel="text"
                               bindValue="id"
                               [ngModel]="countryCodes[0]"
                               (ngModelChange)="countrySelectionChange($event, 0)"
                               (clear)="onRemoved(0)"
                               [placeholder]="countryCodes[0] ? '' : 'No location selected'">
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            <span class="d-flex align-items-center">
                                <i class="{{item.flagClass}} mr-2"></i>
                                <span>{{item.text}}</span>
                            </span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <i class="{{item.flagClass}} mr-2"></i>
                                <span>{{item.text}}</span>
                            </span>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-xs-12 col-md-4 mb-3 mb-md-0">
                    <ng-select [clearable]="true"
                               [items]="countries"
                               bindLabel="text"
                               bindValue="id"
                               [ngModel]="countryCodes[1]"
                               (ngModelChange)="countrySelectionChange($event, 1)"
                               (clear)="onRemoved(1)"
                               [disabled]="isDropdownDisabled(1)"
                               [placeholder]="countryCodes[1] ? '' : 'No location selected'">
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            <span class="d-flex align-items-center">
                                <i class="{{item.flagClass}} mr-2"></i>
                                <span>{{item.text}}</span>
                            </span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <i class="{{item.flagClass}} mr-2"></i>
                                <span>{{item.text}}</span>
                            </span>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-xs-12 col-md-4 mb-3 mb-md-0">
                    <ng-select [clearable]="true"
                               [items]="countries"
                               bindLabel="text"
                               bindValue="id"
                               [ngModel]="countryCodes[2]"
                               (ngModelChange)="countrySelectionChange($event, 2)"
                               (clear)="onRemoved(2)"
                               [disabled]="isDropdownDisabled(2)"
                               [placeholder]="countryCodes[2] ? '' : 'No location selected'">
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            <span class="d-flex align-items-center">
                                <i class="{{item.flagClass}} mr-2"></i>
                                <span>{{item.text}}</span>
                            </span>
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <i class="{{item.flagClass}} mr-2"></i>
                                <span>{{item.text}}</span>
                            </span>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
</div>
@if (isLoading) {
<div class="loading-spinner-container">
    <div class="loading-spinner">
    </div>
</div>
}
<div class="container content-wrapper comparison mt-3">

    <div class="row mb-4 pt-lg-5 mr-0">
        <div class="col">
            <div class="text-md-right">
                <!-- Download information button -->
                <button class="btn btn-info hidden-sm-down" (click)="downloadFile()"
                        [disabled]="!enableDownload() || downloadingContent" [ngClass]="{'btn-loading': downloadingContent}"
                        *featureToggle="features.PdfDownload">
                    Download information <i class="fa fa-download ml-2"></i>
                </button>

                <button class="btn btn-info btn-block hidden-md-up" (click)="downloadFile()"
                        [disabled]="!enableDownload() || downloadingContent" [ngClass]="{'btn-loading': downloadingContent}"
                        *featureToggle="features.PdfDownload">
                    Download information <i class="fa fa-download ml-2"></i>
                </button>
            </div>

            <!-- View more locations button -->
            <div class="text-md-right mt-3">
                <button class="btn btn-info hidden-sm-down" (click)="multipleCountryDownloadPDF()"
                        *featureToggle="features.PdfDownload">
                    View more locations <i class="fa fa-download ml-2"></i>
                </button>

                <button class="btn btn-info btn-block hidden-md-up" (click)="multipleCountryDownloadPDF()"
                        *featureToggle="features.PdfDownload">
                    View more locations <i class="fa fa-download ml-2"></i>
                </button>
            </div>
            <hr class="hidden-sm-down">
        </div>
    </div>

    @if (!primaryCountry) {
    <div class="row hidden-sm-down">
        <div class="col text-center pt-5">
            <p class="h3">No location selected</p>
            <p class="text-muted">Start comparing by selecting from the location selectors above</p>
        </div>
    </div>
    }

    <section class="comparison-section section-depth-1 mt-2 hidden-sm-down">
        <country-comparison-item [primaryCountry]="primaryCountry?.itemConfigs"
                                 [secondaryCountry]="secondaryCountryItemDetails" [tertiaryCountry]="tertiaryCountryItemDetails" [depth]="1">
        </country-comparison-item>
    </section>
</div>


<downloadfile #download></downloadfile>
<multiple-country-comparision-modal #multiCountry id="multiCountryModal" [multiCountryData]="multiCountries"></multiple-country-comparision-modal>